<template>
  <div class="flex">
    <div
      class="circle mr-4 cursor-pointer"
      v-bind:style="circleBackgroundColor"
      v-on:click="click">
    </div>
    <span> {{ text }} </span>
  </div>
</template>


<script>

import Color from 'color'

export default {


  name: 'SpeakolChartFilter',

  props: {

    color: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    },
    value: {
      type: String,
      required: false
    },
    clickable: {
      type: Boolean,
      default: true
    }


  },

  data () {
    return {
      isActive: false
    }
  },

  computed: {
    activeColor () {
      return this.color
    },
    inactiveColor () {
      return Color(this.activeColor).fade(0.8)
    },
    circleBackgroundColor () {
      return {
        'background-color': this.isActive ? this.activeColor : this.inactiveColor
      }
    }
  },

  methods: {
    click () {
      if (this.clickable) {
        this.toggle()
      }
    },

    toggle () {
      this.isActive = !this.isActive
      this.$emit('toggled', { active: this.isActive, value: this.value })
    },


    active () {
      this.isActive = true
      this.$emit('toggled', { active: this.isActive, value: this.value })
    },

    disable () {
      this.isActive = false
      this.$emit('toggled', { active: this.isActive, value: this.value })
    }

  }


}
</script>


<style lang="scss" scoped>
  .circle {
    width: 18px;
    height: 18px;
    border-radius: 50%;
  }
</style>
